import Vue from 'vue'
import Router from 'vue-router'
//import Home from './views/Home.vue'
import Index from './views/Index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      name: 'index',
      component: Index
    },
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/autologin/:token',
      name: 'autologin',
      component: () => import('./views/Autologin.vue')
    },
    /*{
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about"  './views/About.vue')
    },*/
    {
      path: '/search/:search_key',
      name: 'SearchList',
      component: () => import('./views/SearchList.vue')
    },
    {
      path: '/list/:search_key',
      name: 'list',
      component: () => import('./views/List.vue')
    },
    {
      path: '/show/:search_key',
      name: 'show',
      component: () => import('./views/Show.vue')
    },
    {
      path: '/prossimi-tg',
      name: 'ProssimiTg',
      component: () => import('./views/ProssimiTg.vue')
    },
    {
      path: '/search-territorio',
      name: 'SearchTerritorio',
      component: () => import('./views/SearchTerritorio.vue')
    },
    {
      path: '/list-provincia/:provincia/:regione',
      name: 'ListProvincia',
      component: () => import('./views/ListProvincia.vue')
    },
    {
      path: '/search-province/:regione',
      name: 'SearchProvince',
      component: () => import('./views/SearchProvince.vue')
    },
    {
      path: '/presto-online',
      name: 'PrestoOnline',
      component: () => import('./views/PrestoOnline.vue')
    }
  ]
})
